import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { Loyalty } from '../models/loyalty.model';

export class LoyaltyCardsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public loyaltyCards: Loyalty[];
  public getGoogleWalletPass: any;
  public appleWalletPass: any;
  public appleWalletPassFilePath: any;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.loyaltyCards = null;
    this.getGoogleWalletPass = null;
    this.appleWalletPass = null;
    this.appleWalletPassFilePath = null;
  }
}
